import React from 'react';
import { BiLogoLinkedin } from "react-icons/bi";
import mentor1 from './image/mentor1.jpg';
import mentor2 from './image/mentor2.jpeg';
import mentor3 from './image/mentor3.jpg';
import mentor4 from './image/mentor4.jpg';

const mentors = [
  {
    name: "Ayan Kumar Ghosh",
    expertise: "AI, ML/Expert",
    image: mentor1,
    linkedin: "https://www.linkedin.com/in/akghsh?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    alt:'Ayan Kumar Ghosh',
  },
  {
    name: "Abhishek Garg",
    expertise: "DSA/Expert",
    image: mentor2,
    linkedin: "https://www.linkedin.com/in/abhishek-garg-profile",
    alt:'Abhishek Garg',
  },
  {
    name: "Mukesh Joshi",
    expertise: "Web Development/Expert",
    image: mentor3,
    linkedin: "https://www.linkedin.com/in/mukesh-joshi-87444b163?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    alt:'Mukesh Joshi',
  },
  {
    name: "Aman Gupta",
    expertise: "Cyber Security/Cloud Computing",
    image: mentor4,
    linkedin: "https://www.linkedin.com/in/amanguptaiam?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    alt:'Aman Gupta',
  }
];

function All_Program_Mentor() {
  return (
    <div>
      {/* ----------------mobile View-------------------- */}
      <div className='d-sm-block d-md-none'>
        <div className='bg-white'>
          <div className='container py-4'>
            <div className='text-center Mentor_component_text_main'>
              <h1 className=" display-6">Meet Our Mentors</h1>
              <p className="pt-1">A luminary for your success: meet the outstanding mentors who will encourage, uplift, and advance you towards achievement.</p>
            </div>
            <div className='row'>
              {mentors.map((mentor, index) => (
                <div className='col-6' key={index}>
                  <div className='py-3'>
                    <div className='d-flex justify-content-center mb-4'>
                      <img
                        src={mentor.image}
                        className="rounded-circle shadow-1-strong Mentor_card_img"
                        alt={mentor.name}
                      />
                    </div>
                    <div className='text-center Mentor_name_text'>
                      <h4 className="mb-2">{mentor.name}</h4>
                      <p className="mb-2">{mentor.expertise}</p>
                    </div>
                    <div className='container'>
                    <div className='d-flex justify-content-center'>
                      <div className='text-center pt-2'>
                        <a href={mentor.linkedin} target='_blank' rel="noreferrer">
                          <BiLogoLinkedin size="40px" color="#3d2e7c" className='border rounded-pill p-2' />
                        </a>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ----------------------Desktop View---------------------- */}
      <div className='d-none d-md-block'>
        <div className='bg-white'>
          <div className='container py-5'>
            <div className='text-center Mentor_component_text_main'>
              <h1 className="display-6">Meet Our Mentors</h1>
              <p className="py-2">A luminary for your success: meet the outstanding mentors who will encourage, uplift, and advance you towards achievement.</p>
            </div>
            <div className='row py-3'>
              {mentors.map((mentor, index) => (
                <div className='col-md-3' key={index}>
                  <div>
                    <div className='d-flex justify-content-center mb-4'>
                      <img
                        src={mentor.image}
                        className="rounded-circle shadow-1-strong Mentor_card_img"
                        alt={mentor.name}
                      />
                    </div>
                    <div className='text-center Mentor_name_text'>
                      <h4 className="mb-2">{mentor.name}</h4>
                      <p className="mb-2">{mentor.expertise.split('/').map(line => (<>{line}<br /></>))}</p>
                    </div>
                    <div className='d-flex justify-content-center'>
                      <div className='text-center pt-2'>
                        <a href={mentor.linkedin} target='_blank' rel="noreferrer">
                          <BiLogoLinkedin size="40px" color="#3d2e7c" className='border rounded-pill p-2' />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default All_Program_Mentor;